import { Injectable, inject } from "@angular/core";
import { FirebaseCrashlytics } from "@capacitor-firebase/crashlytics";
import { Utils } from "@shared-utils/Utils";

@Injectable({
  providedIn: "root",
})
export class CrashlyticsService {
  private utils = inject(Utils);

  crash(message: string): Promise<void> {
    if (!this.utils.isPluginAvailable("FirebaseCrashlytics")) {
      return;
    }
    return FirebaseCrashlytics.crash({ message });
  }

  setCustomKey(
    key: string,
    value: string,
    type: "string" | "boolean" | "long" | "double" | "int" | "float",
  ): Promise<void> {
    if (!this.utils.isPluginAvailable("FirebaseCrashlytics")) {
      return;
    }
    return FirebaseCrashlytics.setCustomKey({
      key,
      value,
      type,
    });
  }

  setUserId(userId: string): Promise<void> {
    if (!this.utils.isPluginAvailable("FirebaseCrashlytics")) {
      return;
    }
    FirebaseCrashlytics.setUserId({
      userId,
    });
  }

  log(message: string): Promise<void> {
    if (!this.utils.isPluginAvailable("FirebaseCrashlytics")) {
      return;
    }
    return FirebaseCrashlytics.log({
      message,
    });
  }

  toggleCrashlytics(isEnabled: boolean): Promise<void> {
    if (!this.utils.isPluginAvailable("FirebaseCrashlytics")) {
      return;
    }
    return FirebaseCrashlytics.setEnabled({
      enabled: isEnabled,
    });
  }

  async isEnabled(): Promise<boolean> {
    if (!this.utils.isPluginAvailable("FirebaseCrashlytics")) {
      return;
    }
    const { enabled } = await FirebaseCrashlytics.isEnabled();
    return enabled;
  }

  async didCrashOnPreviousExecution(): Promise<boolean> {
    if (!this.utils.isPluginAvailable("FirebaseCrashlytics")) {
      return;
    }
    const { crashed } = await FirebaseCrashlytics.didCrashOnPreviousExecution();
    return crashed;
  }

  recordException(message: string): Promise<void> {
    if (!this.utils.isPluginAvailable("FirebaseCrashlytics")) {
      return;
    }
    return FirebaseCrashlytics.recordException({
      message,
    });
  }
}
